import I18n from 'I18n';
import styled from 'styled-components';
import { mediaQueries, MOBILE_MENU_BREAKPOINT } from 'developer-docs-shared-components/utils/mediaQueries';
import UIScreenReaderOnly from 'UIComponents/text/UIScreenReaderOnly';
import { HEFFALUMP } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A button, only visible at narrower breakpoints when the hamburger mobile
 * is visible. Contains actionable text for users of assistive technology.
 */
const Button = styled.button.withConfig({
  displayName: "HamburgerMenu__Button",
  componentId: "sc-1ccfotb-0"
})(["position:absolute;right:10px;top:19px;width:33px;height:33px;background:none;border:none;border-radius:0;cursor:pointer;display:block;transition:all 0.25s ease-in-out;padding:0;", "{display:none;}"], mediaQueries.aboveWidth(MOBILE_MENU_BREAKPOINT));

/**
 * Shared attributes for a `<rect />` element.
 */
const Rect = styled(props => /*#__PURE__*/_jsx("rect", Object.assign({}, props, {
  width: "33",
  height: "3.01508",
  rx: "1.50754",
  fill: HEFFALUMP
}))).withConfig({
  displayName: "HamburgerMenu__Rect",
  componentId: "sc-1ccfotb-1"
})(["opacity:1;transform:rotate(0) translateY(0) translateX(0);transition:transform 0.3s ease-in-out,opacity 0.2s ease-in-out;"]);

/**
 * The top line of the hamburger menu.
 */
const RectTop = styled(Rect).withConfig({
  displayName: "HamburgerMenu__RectTop",
  componentId: "sc-1ccfotb-2"
})(["transform-origin:7px 7px;transform:", ";"], ({
  open
}) => open && 'rotate(45deg) translateY(0) translateX(0)');

/**
 * The middle line of the hamburger menu.
 */
const RectMiddle = styled(Rect).withConfig({
  displayName: "HamburgerMenu__RectMiddle",
  componentId: "sc-1ccfotb-3"
})(["opacity:", ";"], ({
  open
}) => open && '0');

/**
 * The bottom line of the hamburger menu.
 */
const RectBottom = styled(Rect).withConfig({
  displayName: "HamburgerMenu__RectBottom",
  componentId: "sc-1ccfotb-4"
})(["transform-origin:7px 12px;transform:", ";"], ({
  open
}) => open && 'rotate(-45deg) translateY(0em) translateX(0em)');
const IconSVG = styled.svg.withConfig({
  displayName: "HamburgerMenu__IconSVG",
  componentId: "sc-1ccfotb-5"
})(["width:33px;height:33px;", "{display:none;}"], mediaQueries.aboveWidth(MOBILE_MENU_BREAKPOINT));

/**
 * The hamburger menu, shown at narrower viewports.
 */
const HamburgerMenu = ({
  onClick,
  open
}) => {
  return /*#__PURE__*/_jsxs(Button, {
    "aria-expanded": "false",
    onClick: onClick,
    children: [/*#__PURE__*/_jsx(UIScreenReaderOnly, {
      children: I18n.text(`developer-docs-ui.header.primaryNav.mobileMenuLabel`)
    }), /*#__PURE__*/_jsxs(IconSVG, {
      "aria-hidden": "true",
      xmlns: "http://www.w3.org/2000/svg",
      width: "33",
      height: "20",
      viewBox: "0 0 33 20",
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx(RectTop, {
        open: open
      }), /*#__PURE__*/_jsx(RectMiddle, {
        open: open,
        y: "8.04022"
      }), /*#__PURE__*/_jsx(RectBottom, {
        open: open,
        y: "16.0804"
      })]
    })]
  });
};
export default HamburgerMenu;